import React from 'react'

import { Typeof } from 'utils';

import classnames from 'classnames';

import './style.css';
import noPicture from 'assets/no-picture.png'

class ProfilePicture extends React.Component {

  constructor(props) {
    super(props);

    this.getSource = this.getSource.bind(this);
  }

  getSource() {

    if(Typeof.string(this.props.srcBase64)) {

      return `data:image/png;base64,${this.props.srcBase64}`
    }

    if(this.props.src === undefined)
    {
      return noPicture;
    }

    return this.props.src;
  }

  render() {

    let className = classnames('profile-picture', this.props.size);

    return (
      <img alt="Profile pic" className={className} src={this.getSource()} />
    )
  }
}

export default ProfilePicture;
